import React from 'react'
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';


function MissionAndVision({ data }) {


    return (
        <div>
            <section className="why-choose-two mt-0 pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 ">
                            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{data && data?.Mission}</ReactMarkdown>
                            <div style={{ marginTop: 100 }}>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]}>{data && data.Vision}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default MissionAndVision